/**
 * Extract up to the first two uppercase initials from a name.
 *
 * @param name       The full name (e.g. "Jane Q Smith").
 * @param separator  Regex for splitting the name into parts. Defaults to
 *                   whitespace. Pass a comma-aware regex for customer names
 *                   that may use "Last, First" formatting.
 */
export function getInitials(name: string, separator: RegExp = /\s+/): string {
  return name
    .split(separator)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
